/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - CSS
 */
import './styles/Container.css'

export default class Container extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <div
                className={`container${(this.props.fullwidth) ? ' container--full' : ''} 
                ${this.props.className || ''} 
                ${(this.props.shadow) ? ' container--shadow' : ''}`}
            >
                <div>
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Container/Container.tsx